export enum SelectIconTheme {
  angle = 'angle',
  triangle = 'triangle'
}
